class Api {
  _init = async () => {
    document.getElementById("viewport").setAttribute("content", "width=1280, initial-scale=1.0, user-scalable=no")
  }

  addListeners = () => {}
  makeConfigurations = async () => {}
  loadResources = async () => {}
}

export default Api
